// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"bea87951","276":"4514cca4","592":"7790ba43","604":"fde71792","620":"385e857d","796":"1c13e1f3","812":"d6860577","992":"d1bea3d4"}[chunkId] + ".chunk.js";
};